<div class="container main-font padding-page">
  <div class="row mx-3 mb-3 g-4">
    <!-- Lista Teams  -->
    <!-- <app-card-lista-teams class="col-6"></app-card-lista-teams> -->

    <!--         <app-percorso-di-crescita class="" [readOnly]="true"></app-percorso-di-crescita>

        <app-card-notifiche class="mb-3"></app-card-notifiche> -->

    <!-- SHORTCUT NOTIFICHE -->
    <div
      class="card-box col-lg-6 col-md-12 col-sm-12 cursor-pointer"
      routerLink="../notifiche">
      <mat-card class="cut-card">
        <mat-card-header class="card-padding mb-2">
          <mat-card-title-group class="h3 text-title">
            Notifiche non lette
          </mat-card-title-group>
        </mat-card-header>

        <mat-card-content>
          <ng-container *ngIf="isNotificationsEmpty(); else showNotifications">
            <p class="notification">Nessuna nuova notifica</p>
          </ng-container>

          <ng-template #showNotifications>
            <mat-list>
              <div class="overflow-auto h-list">
                <mat-list-item
                  class="notification-list"
                  *ngFor="let message of notification"
                  routerLink="../notifiche">
                  <mat-icon matListItemIcon class="mail">mail</mat-icon>
                  <div
                    matListItemTitle
                    class="text-wrap text-message d-flex flex-column justify-content-center gap-1">
                    <p class="notification-font m-0">
                      {{
                        message.data.category == 'Feedback 360' ||
                        message.data.category == 'Autovalutazione' ||
                        message.data.category == 'Sondaggi'
                          ? message.data.alias?.length <= numberSlice
                            ? message.data.alias
                            : message.data.alias.slice(0, numberSlice) + '...'
                          : message.data.message?.length <= numberSlice
                            ? message.data.message
                            : message.data.message.slice(0, numberSlice) + '...'
                      }}
                    </p>

                    <p class="main-font notification-date text-secondary m-0">
                      {{ message.created_at | date: 'd/MM/yyyy, HH:mm' }}
                    </p>
                  </div>
                  <!-- <div *ngIf="isMobile" matListItemTitle class="text-wrap text-message">{{message.data.message.length <= 50 ? message.data.message : (message.data.message.slice(0, 50) + '...')}}</div> -->
                  <!-- <div *ngIf="isTablet" matListItemTitle class="text-wrap text-message">{{message.data.message.length <= 70 ? message.data.message : (message.data.message.slice(0, 70) + '...')}}</div> -->
                </mat-list-item>
              </div>
            </mat-list>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
